const GraphQLMutation = require('app/graphql/Mutation');


class Editor {

    defaultOptions(){
        return {
            '$textarea': null,
            'height': 500,
            'menubar': 'edit insert format table tools help',
            'plugins': 'quickbars table image link lists media autoresize help',
            'toolbar': 'undo redo | blocks | bold italic | alignleft aligncentre alignright alignjustify | indent outdent | bullist numlist',
        };
    }

    constructor(options){
        this.settings = $.extend(this.defaultOptions(),options);

        this.$textarea = this.settings.$textarea;
        if(!this.$textarea){
            console.error("$textarea settings is mandatory for Editor");
        }

        // initalize object
        this.initialize();
    }


    initialize(){
        this.$textarea.tinymce(this.buildOptions());
    }


    buildOptions(){
        var self = this;
        let language = 'en_US';
        switch(window.App.get('locale')){
            case 'fr':
                language = 'fr_FR';
            break;
        }
        return {
            'branding': false,
            'promotion': false,
            'height': this.settings.height,
            'setup': function(editor){
                self.editor = editor;
                editor.on('change', function () {
                    editor.save();
                });
            },
            'language': language,
            'menubar': this.settings.menubar,
            'plugins': this.settings.plugins,
            'toolbar': this.settings.toolbar,
        };
    }

    show(){
        this.$textarea.tinymce(this.buildOptions());
    }

    destroy(){

    }

    getContent(){
        if(this.editor){
            return this.editor.getContent();
        }
        return this.$textarea.val();
    }

}

module.exports = Editor;